import { Injectable } from '@angular/core';
import { Client } from '../Module/Client.model';
import { MatDialog } from '@angular/material/dialog';
import { SelectClientPopUpComponent } from '../select-client-pop-up/select-client-pop-up.component';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private client: Client = new Client();
  private orderId?: number;
  private productCode?: number;
  private targetRoute: string = 'addOrder'; // Default route

  constructor(private notificationService: NotificationService, private dialog: MatDialog) {}

  // Order ID
  setOrderId(id: number): void {
    this.orderId = id;
  }

  getOrderId(): number | undefined {
    return this.orderId;
  }

  // Product Code
  setProductCode(code: number): void {
    this.productCode = code;
  }

  getProductCode(): number | undefined {
    return this.productCode;
  }

  // Client
  setClient(client: Client): void {
    this.client = client;
  }

  getClient(): Client {
    return this.client;
  }

  // Target Route
  setTargetRoute(route: string): void {
    this.targetRoute = route;
  }

  getTargetRoute(): string {
    return this.targetRoute;
  }

  // Snackbar - Updated to use custom notification service
  showSnackbar(msg: string, type: 'success' | 'info' | 'warning' | 'error' = 'info'): void {
    this.notificationService.show(msg, type);
  }

// Open Client Selection Dialog
openClientFormDialog(target?: 'addOrder' | 'addCashLoan'): void {
  if (target) {
    this.setTargetRoute(target);
  }
  const dialogRef = this.dialog.open(SelectClientPopUpComponent);

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      console.log('Client selected/created:', result);
    }
  });
}
}
